import { screenNotEmpty, moreThanOneLivePeriodPlayed, atLeastOneLivePeriodStarted, isNotMinimumCoverage, prevPeriodNotShootout } from '../../statements';
import { AdFileSize } from '@ligr/api-v2';
import { getPrevPeriod } from '@ligr/shared';
const defaultBreakSizes = [AdFileSize.large, AdFileSize.xLarge, AdFileSize.long];
export const playersEnteringNotPregame = {
    name: 'playersEnteringPitch',
    priority: 2,
    transitions: [
        ['action:hideAll', 0, { guard: screenNotEmpty }],
        ['status', 2, { adSizes: [...defaultBreakSizes] }],
        ['action:hideAll', 10],
        [
            'teamStats',
            12,
            {
                guard: [isNotMinimumCoverage, atLeastOneLivePeriodStarted],
                adSizes: [...defaultBreakSizes]
            }
        ],
        ['action:hideAll', 27]
    ]
};
export const playersEnteringPregame = {
    name: 'playersEnteringPitchPregame',
    priority: 2,
    transitions: [
        ['action:hideAll', 0, { guard: screenNotEmpty }],
        ['matchId', 2, { adSizes: [...defaultBreakSizes] }],
        ['action:hideAll', 10],
        ['status', 12, { adSizes: [...defaultBreakSizes] }],
        ['action:hideAll', 19]
    ]
};
export const periodAboutToStart = {
    name: 'periodAboutToStart',
    priority: 2,
    transitions: [
        ['action:hideAll', 0, { guard: screenNotEmpty }],
        [
            'status',
            2,
            {
                adSizes: [...defaultBreakSizes],
                dataPreset: 'nextPeriodIntro'
            }
        ],
        ['action:hideAll', 10]
    ]
};
export const pregame = {
    name: 'pregame',
    priority: 2,
    transitions: [
        ['background', 0],
        [
            'intro',
            2,
            {
                updateType: 'update',
                adLoop: true,
                adLoopConfig: {
                    type: 'everyXSecs',
                    secsPerShow: 30,
                    secsBetweenShows: 3,
                    enabled: true,
                    perPeriod: null
                },
                adLoopSizes: [AdFileSize.long, AdFileSize.large, AdFileSize.xLarge, AdFileSize.medium]
            }
        ]
    ]
};
export const longBreak = args => ({
    name: 'longBreak',
    priority: 2,
    startFromMissedOffset: true,
    missedOffsetBuffer: 60,
    transitions: [
        ['action:hideAll', 0, { guard: screenNotEmpty }],
        ['status', 2, { adSizes: [...defaultBreakSizes] }],
        ['action:hideAll', 10],
        [
            'teamStats',
            12,
            {
                guard: [isNotMinimumCoverage, moreThanOneLivePeriodPlayed, prevPeriodNotShootout],
                periodCode: getPrevPeriod(args.matchSummary).code,
                adSizes: [...defaultBreakSizes]
            }
        ],
        [
            'action:hideAll',
            42,
            {
                guard: [isNotMinimumCoverage, moreThanOneLivePeriodPlayed, prevPeriodNotShootout]
            }
        ],
        [
            'teamStats',
            52,
            {
                guard: [isNotMinimumCoverage],
                adSizes: [...defaultBreakSizes]
            }
        ],
        ['action:hideAll', 76],
        ['status', 84, { adSizes: [...defaultBreakSizes] }],
        ['action:hideAll', 92],
        ['background', 102],
        [
            'intro',
            104,
            {
                updateType: 'update',
                adLoop: true,
                adLoopSizes: [AdFileSize.long, AdFileSize.large, AdFileSize.xLarge, AdFileSize.medium],
                adLoopConfig: {
                    type: 'everyXSecs',
                    secsPerShow: 30,
                    secsBetweenShows: 3,
                    enabled: true,
                    perPeriod: null
                }
            }
        ]
    ]
});
export const shortBreak = args => ({
    priority: 2,
    name: 'shortBreak',
    startFromMissedOffset: true,
    missedOffsetBuffer: 30,
    transitions: [
        ['action:hideAll', 0, { guard: screenNotEmpty }],
        ['status', 2, { adSizes: [...defaultBreakSizes] }],
        ['action:hideAll', 8],
        [
            'teamStats',
            10,
            {
                guard: [isNotMinimumCoverage, moreThanOneLivePeriodPlayed],
                periodCode: getPrevPeriod(args.matchSummary).code,
                adSizes: [...defaultBreakSizes]
            }
        ],
        ['action:hideAll', 32],
        [
            'teamStats',
            34,
            {
                guard: [isNotMinimumCoverage],
                adSizes: [...defaultBreakSizes]
            }
        ],
        ['action:hideAll', 54],
        ['background', 56],
        [
            'intro',
            58,
            {
                updateType: 'update',
                adLoop: true,
                adLoopConfig: {
                    type: 'everyXSecs',
                    secsPerShow: 30,
                    secsBetweenShows: 3,
                    enabled: true,
                    perPeriod: null
                },
                adLoopSizes: [AdFileSize.long, AdFileSize.large, AdFileSize.xLarge, AdFileSize.medium]
            }
        ]
    ]
});
//# sourceMappingURL=break.js.map